import { ApplicationConfig, APP_INITIALIZER, InjectionToken, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, HttpClient, withInterceptors } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';

import { routes } from './app.routes';
import { authConfig } from './auth/auth.config';
import { authHttpInterceptor } from './auth/auth-http.interceptor';
import { SpaceConfigOptionsService } from './services/space-config-options.service';

// Factory function for TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Captured at module load time, before APP_INITIALIZER wipes the OIDC params from the URL.
const isOidcCallbackLaunch: boolean =
  typeof window !== 'undefined' &&
  window.location.search.includes('code=') &&
  window.location.search.includes('state=');

export const IS_OIDC_CALLBACK_LAUNCH = new InjectionToken<boolean>('IS_OIDC_CALLBACK_LAUNCH');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(withInterceptors([authHttpInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (s: SpaceConfigOptionsService) => () => s.load(),
      deps: [SpaceConfigOptionsService],
      multi: true
    },
    provideAuth(
      {
        config: authConfig
      },
      withAppInitializerAuthCheck()
    ),
    { provide: IS_OIDC_CALLBACK_LAUNCH, useValue: isOidcCallbackLaunch },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
};
